'use strict'

class ItemPlannerCampaignFormCtrl {

    constructor (
        $http,
        $rootScope,
        $scope,
        moment,
        $state,
        $stateParams,
        Campaign,
        $mdDialog,
        $mdToast,
        itemData,
        Item,
    ) {

        // Dependencies
        this.$http = $http
        this.$mdDialog = $mdDialog
        this.$stateParams = $stateParams
        this.today = moment().format('YYYY-MM-DD')
        this.$mdToast = $mdToast
        this.itemData = itemData
        this.$scope = $scope

        this.$state = $state
        this._Campaign = Campaign
        this._Item = Item
        this.doNotWarn = false

        this.items = []
        this.itemCount = 0
        this.itemCustomFieldsRaw = []
        this.customFieldsRaw = []
        this.customFields = {}
        this.setEmptyCampaign()

        this.getCampaignData()
    }

    setEmptyCampaign () {
        this.formdataCopy = null
        this.formdata = {
            item: {},
            recommended: true,
            startTime: '00:00:00',
            stopTime: '00:00:00',
        }
    }

    getCampaignData () {
        this.setEmptyCampaign()

        this.getModelTypes().then(() => {
            if (this.customFieldsRaw.length < 2) {
                this.formdata.model_type_id = this.customFieldsRaw[0].id
            }

            if (this.$stateParams.id) {
                this._Campaign.get({ id: this.$stateParams.id }, (data) => {

                    delete data.$promise

                    angular.extend(this.formdata, data)
                    this.formdata.model_type_id = data.model_type_id
                    this.fixDates()

                    this.itemData.setItemObj(this.formdata.item)
                    this.itemData.notify('item')

                    //Copy dataform so we can reverse the data on cancel
                    this.formdataCopy = angular.copy(this.formdata)
                })

                this.fetchItems(this.$stateParams.id)
            } else {
                // default type
                this.itemData.setItemObj({})
                this.formdata.model_type_id = this.customFieldsRaw[0].id
            }
        })
    }

    getModelTypes () {
        // We need these for scheme
        this.$http.get('/modeltypes/item', { cache: true }).then((response) => {
            this.itemCustomFieldsRaw = response.data.item
            this.formdata.item_model_type = this.itemCustomFieldsRaw[0].id
        })
        return this.$http.get('/modeltypes/campaign', { cache: true }).then((response) => {
            this.customFieldsRaw = response.data.campaign
            response.data.campaign.forEach((data) => {
                this.customFields[data.id] = data.fields
            })
            return response.data
        })
    }

    cancel () {
        this.$state.go('item-planner')
    }

    save ($valid) {

        if (!$valid) {
            return
        }

        let modelData = angular.copy(this.formdata)

        modelData.description = this.formdata.description

        //map the ids from contacts instead of whole contact object
        if (this.formdata.item.contacts) {
            modelData.item.contacts = this.formdata.item.contacts.map((contact) => {
                return contact.id
            })
        }

        modelData.start = moment(moment(this.formdata.startDay).format('YYYY-MM-DD') + ' ' + this.formdata.startTime, 'YYYY-MM-DD HH:mm:ss')
        modelData.stop = moment(moment(this.formdata.stopDay).format('YYYY-MM-DD') + ' ' + this.formdata.stopTime, 'YYYY-MM-DD HH:mm:ss')

        //check if dates are not before mindate and each other
        if (moment(modelData.stop).isBefore(modelData.start)) {
            this.$mdToast.show({
                templateUrl: '/partial/app.partials.toasts.error?title=action_stop_before_start_date',
                hideDelay: 3000,
                position: ('top right')
            })
            return
        }

        if (modelData.items) {
            delete modelData.items
        }

        if (modelData.item_count) {
            delete modelData.item_count
        }

        this.buttonDisabled = true

        //Disable not save reminder confirm box
        this.doNotWarn = true

        this._Campaign.save(modelData, (data) => {

            if (this.formdata.id) {
                this.$mdToast.show({
                    templateUrl: '/partial/app.partials.toasts.saved?object=campaign&title=' + this.formdata.title, //@trans('labels.campaign')
                    hideDelay: 3000,
                    position: ('top right')
                })

                this.$state.go('item-planner', { id: this.formdata.id }, { 'reload': true })

            } else {
                this.$mdToast.show({
                    templateUrl: '/partial/app.partials.toasts.create?object=campaign&title=' + this.formdata.title, //@trans('labels.campaign')
                    hideDelay: 3000,
                    position: ('top right')
                })

                //temporary go to update because of the schema items bug
                this.$state.go('item-planner', { id: data.id }, { 'reload': true })
            }

            //remove item object from service
            this.itemData.setItemObj({})
        })
    }

    fixDates () {
        const { formdata } = this

        if (formdata.start) {
            formdata.startDay = new Date(formdata.start)
            formdata.startTime = moment(formdata.startDay).format('HH:mm:ss')
        }

        if (formdata.stop) {
            formdata.stopDay = new Date(formdata.stop)
            formdata.stopTime = moment(formdata.stopDay).format('HH:mm:ss')
        }
    }

    fetchItems (campaignId) {
        this.$http.get('items/campaign/' + campaignId).then((response) => {
            this.items = response.data
            this.stationId = window.CONFIG.station_id
        })
    }

    get hours () {

        let hours = []

        for (let i = 0; i < 24; i++) {

            let format = (i < 10) ? '0' + i : i

            format += ':00'

            hours.push(format)
        }

        return hours
    }

    showRevisions (event) {

        this.$http.get('/revisions/campaigns/' + this.$stateParams.id).then(revisions => {

            this.$mdDialog.show({

                controller: 'RevisionDialogCtrl',
                templateUrl: 'revisionDialog.ngTemplate',
                parent: angular.element(document.querySelector('#popupContainer')),
                targetEvent: event,
                clickOutsideToClose: true,
                locals: {
                    revisions: revisions.data
                }
            }).then(values => {
                this.formdata.title = values.title
                this.formdata.model_type_id = values.model_type_id
                this.formdata.start = moment(values.start).toDate()
                this.formdata.stop = moment(values.stop).toDate()

                this.formdata.item = values.item
                this.itemData.setItemObj(values.item)
                this.itemData.notify('item')

                this.formdata.recommended = values.recommended
                this.formdata.description = values.description
            }).catch(error => {
                console.error({ error, event })
            })
        })
    }

}

ItemPlannerCampaignFormCtrl.$inject = [
    '$http',
    '$rootScope',
    '$scope',
    'moment',
    '$state',
    '$stateParams',
    'Campaign',
    '$mdDialog',
    '$mdToast',
    'itemData',
    'Item',
]

module.exports = ItemPlannerCampaignFormCtrl
